import React from 'react';
import { Steps } from 'antd';
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
const Step = Steps.Step;
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';


class SgiSteps extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state属性
        this.initState();
        this.state = {
            ...this.state,
            store: [], //下拉框内容
            current: 0,
            storeKey: {},
            functions: {}, //存储已转义好的上下步函数
            prvNxtEventFlg: false, //是否启用上下步事件
            stepEvents: [], //事件数组
            scList: [], //存储标准代码对应节点列表
            orderToKey: {}, //通过current值找到对应的
        };
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    steps_mk(parentModule, moduleDesc, bdInst, workspace, type) {

        //获取需要展示的数据信息
        var moduleDesc = this.props.moduleDesc;
        if (!moduleDesc) {
            return;
        }
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //组装下拉框内容
        this.fitSelectOption(moduleDesc);
        //转换form公共属性
        // AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        // setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        // bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        // bindValue(this, moduleDesc, bdInst, this.state.formItemProps, this.state.inputprops);
    }

    /**
     * 组装下拉框内容
     * @param {描述} moduleDesc
     */
    fitSelectOption(moduleDesc) {

        this.state.store = [];
        this.state.storeKey = {};
        var scId = moduleDesc.rSC; //绑定实例名
        if (!scId) {
            return;
        }
        // 下拉窗列表值在标准代码中的id
        var comboBoxData = StandardCode.getSC(scId);
        if (!comboBoxData) {
            return;
        }

        let scList = [];
        let orderToKey = {};
        var size = comboBoxData.length;
        if (!size == 0) {
            for (let i = 0; i < size; i++) {
                var item = comboBoxData[i];
                scList.push({ te: (item.te), c: (item.c), desc: this.state.showAnn ? item.ann : null });
            }

            scList.forEach((item, index) => {
                this.state.store.push(<Step key={item.c} title={item.te} description={item.desc} />);
                this.state.storeKey[item.c] = index;
                orderToKey[index] = item.c;
            })

            this.state.orderToKey = orderToKey;
            this.state.scList = scList;
        }
    }

    setShowKeys(showKeys) {
        showKeys = showKeys || [];

        this.state.store = [];

        let showList = [];
        const allList = this.state.scList || [];
        let orderToKey = {};

        allList.forEach(all => {
            showKeys.forEach(showKey => {
                if (all["c"] === showKey) {
                    showList.push(all);
                }
            });
        });

        showList.forEach((item, index) => {
            this.state.store.push(<Step key={item.c} title={item.te} description={item.desc} />);
            orderToKey[index] = item.c;
        })

        this.state.orderToKey = orderToKey;
        this.loadCurrentPanel(0);
        this.setState({ loading: false });
    }

    loadCurrentPanel(current) {
        current = current || this.state.current;
        const orderToKey = this.state.orderToKey || {};
        // 执行进入事件
        if (this.state.prvNxtEventFlg) {
            let $nextInLsn = this.state.functions["nextInLsn_" + (orderToKey[current])];
            if (!$nextInLsn) {
                const currStepDesc = this.getItemByCode(orderToKey[current]) || {};
                const nextInLsn = currStepDesc.nextInLsn;
                if (nextInLsn) {
                    try {
                        $nextInLsn = new Function("module", "objFct", "current", nextInLsn);
                    } catch (error) {
                        sgiLogger.eventErr(error);
                    }
                    this.state.functions["nextInLsn_" + (orderToKey[current])] = $nextInLsn;
                }
            }
            if ($nextInLsn) {
                const { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
                tool.sgiLogger.log("下一步进入事件");
                if ($nextInLsn(this, objFct, current) === false) {
                    return false;
                }
            }

        }
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, formItem, inputprops) {
        //csstyle 样式文件?这个我还不知道怎么用
        // var csstyle = moduleDesc.csstyle;

        // 指定当前步骤，从 0 开始记数。
        var current = moduleDesc.current;
        if (current) this.state.current = current;

        //点状步骤条
        var progressDot = moduleDesc.progressDot;
        if (progressDot) inputprops.progressDot = progressDot;

        //步骤条方向
        var direction = moduleDesc.direction;
        if (direction) inputprops.direction = direction;

        // 是否启用上下步事件
        const cstmEvent = moduleDesc.cstmEvent;
        this.state.prvNxtEventFlg = !!cstmEvent;

        // 事件数组
        const stepEvents = moduleDesc.stepEvents;
        this.state.stepEvents = stepEvents || [];

        // 显示注释内容
        this.state.showAnn = !!moduleDesc.showAnn;

        // 让步骤条可点击
        var stepIsClick = moduleDesc.stepIsClick;
        inputprops.onChange = current => {
            // let max = this.state.store.length - 1;
            // if (this.state.current < max) {
            // 执行事件
            if (this.state.prvNxtEventFlg) {
                if (this._nextOutEvent() === false) return false;
                // if (this._nextInEvent(current) === false) return false;
            }
            // 下一步
            this._nextStep(current);
            // 执行事件
            if (this.state.prvNxtEventFlg) {
                // if (this._nextOutEvent() === false) return false;
                if (this._nextInEvent(current) === false) return false;
            }
            return true;
            // }
        };
    }

    getItemByCode(code) {
        if (!code) return null;
        const stepEvents = this.state.stepEvents || [];
        for (const item of stepEvents) {
            if (item["c"] === code) {
                return item;
            }
        }
    }

    // 下一步--先执行事件、再切换页面
    next() {
        let max = this.state.store.length - 1;
        if (this.state.current < max) {
            // 执行事件
            if (this.state.prvNxtEventFlg) {
                if (this._nextOutEvent() === false) return false;
                // if (this._nextInEvent() === false) return false;
            }
            // 下一步
            this._nextStep();
            // 执行事件
            if (this.state.prvNxtEventFlg) {
                // if (this._nextOutEvent() === false) return false;
                if (this._nextInEvent() === false) return false;
            }
            return true;
        }
    }
    // 下一步--只执行事件
    nextEvent() {
        let max = this.state.store.length - 1;
        if (this.state.current < max) {
            if (this.state.prvNxtEventFlg) {
                if (this._nextOutEvent() === false) return false;
                if (this._nextInEvent() === false) return false;
            }
            return true;
        }
    }
    // 当前步离开事件
    nextOutEvent() {
        let max = this.state.store.length - 1;
        if (this.state.current < max) {
            if (this.state.prvNxtEventFlg) return this._nextOutEvent();
            return true;
        }
    }
    // 下一步进入事件
    nextInEvent() {
        let max = this.state.store.length - 1;
        if (this.state.current < max) {
            if (this.state.prvNxtEventFlg) return this._nextInEvent();
            return true;
        }
    }
    // 下一步--只执行页面切换
    nextStep() {
        let max = this.state.store.length - 1;
        if (this.state.current < max) {
            return this._nextStep();
        }
    }
    // 上一步--先执行事件，在执行页面切换
    prev() {
        if (this.state.current > 0) {
            // 切换页面
            this._prevStep();
            // 执行事件
            if (this.state.prvNxtEventFlg) {
                if (this._prevEvent() === false) return false;
            }
            return true;
        }
    }
    // 上一步--只执行事件
    prevEvent() {
        if (this.state.current > 0) {
            if (this.state.prvNxtEventFlg) {
                if (this._prevEvent() === false) return false;
            }
            return true;
        }
    }
    // 上一步--只切换页面
    prevStep() {
        if (this.state.current > 0) {
            this._prevStep();
            return true;
        }
    }

    setStep(code) {
        if (!code) {
            return;
        }
        let current = this.state.storeKey[code]
        if (current == undefined || current == null) {
            return;
        }
        this.setState({ current });
    }

    getCurrent() {
        const current = this.state.current;
        const max = this.state.store.length - 1;
        const type = current === 0 ? "first" : (current === max ? "last" : (current === (max - 1) ? "nextToLast" : "middle"));
        const uis = (this.state.store || []).map((item, index) => (this.getItemByCode(this.state.orderToKey[index]) || {}).uid);
        return {
            current,
            max,
            type,
            uis
        };
    }

    // 下一步进入事件
    _nextInEvent(nextCurrent) {

        let _nextCurrent = this.state.current + 1;
        if (nextCurrent || nextCurrent == 0) {
            _nextCurrent = nextCurrent;
        }

        const orderToKey = this.state.orderToKey || {};
        let $nextInLsn = this.state.functions["nextInLsn_" + (orderToKey[_nextCurrent])];
        if (!$nextInLsn) {
            const nextStepDesc = this.getItemByCode(orderToKey[_nextCurrent]) || {};
            const nextInLsn = nextStepDesc.nextInLsn;
            if (nextInLsn) {
                try {
                    $nextInLsn = new Function("module", "objFct", "current", nextInLsn);
                } catch (error) {
                    sgiLogger.eventErr(error);
                }
                this.state.functions["nextInLsn_" + (orderToKey[_nextCurrent])] = $nextInLsn;
            }
        }
        if ($nextInLsn) {
            const { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            tool.sgiLogger.log("下一步进入事件");
            if ($nextInLsn(this, objFct, _nextCurrent) === false) {
                return false;
            }
        }
        return true;
    }
    // 当前步离开事件
    _nextOutEvent() {
        const orderToKey = this.state.orderToKey || {};
        let $nextOutLsn = this.state.functions["nextOutLsn_" + orderToKey[this.state.current]];
        if (!$nextOutLsn) {
            const thisStepDesc = this.getItemByCode(orderToKey[this.state.current]) || {};
            const nextOutLsn = thisStepDesc.nextOutLsn;
            if (nextOutLsn) {
                try {
                    $nextOutLsn = new Function("module", "objFct", "current", nextOutLsn);
                } catch (error) {
                    sgiLogger.eventErr(error);
                }
                this.state.functions["nextOutLsn_" + orderToKey[this.state.current]] = $nextOutLsn;
            }
        }
        if ($nextOutLsn) {
            const { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            tool.sgiLogger.log("当前步离开事件");
            if ($nextOutLsn(this, objFct, this.state.current) === false) {
                return false;
            }
        }
        return true;
    }
    // 下一步
    _nextStep(nextCurrent) {

        let _nextCurrent = this.state.current + 1;
        if (nextCurrent || nextCurrent == 0) {
            _nextCurrent = nextCurrent;
        }

        // 页面跳转
        const orderToKey = this.state.orderToKey || {};
        const nextStepDesc = this.getItemByCode(orderToKey[_nextCurrent]) || {};
        const nextUid = nextStepDesc.uid;
        if (nextUid) {
            tool.setActiveWV(nextUid, this.props.objFct);
        }
        // 下一步
        this.setState({ current: _nextCurrent });
    }

    // 上一步事件
    _prevEvent() {
        const orderToKey = this.state.orderToKey || {};
        let $prevLsn = this.state.functions["prevLsn_" + orderToKey[this.state.current]];
        if (!$prevLsn) {
            const thisStepDesc = this.getItemByCode(orderToKey[this.state.current]) || {};
            const prevLsn = thisStepDesc.prevLsn;
            if (prevLsn) {
                try {
                    $prevLsn = new Function("module", "objFct", "current", prevLsn);
                } catch (error) {
                    sgiLogger.eventErr(error);
                }
                this.state.functions["prevLsn_" + orderToKey[this.state.current]] = $prevLsn;
            }
        }
        if ($prevLsn) {
            const { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            tool.sgiLogger.log("上一步事件");
            if ($prevLsn(this, objFct, this.state.current) === false) {
                return false;
            }
        }
        return true;
    }
    // 上一步
    _prevStep() {
        // 页面跳转
        const orderToKey = this.state.orderToKey || {};
        const prevStepDesc = this.getItemByCode(orderToKey[this.state.current - 1]) || {};
        const prevUid = prevStepDesc.uid;
        if (prevUid) {
            tool.setActiveWV(prevUid, this.props.objFct);
        }
        // 上一步
        this.setState({ current: this.state.current - 1 });
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.steps_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        const { current } = this.state;
        return (
            <Steps {...this.state.inputprops} current={current}>{this.state.store}</Steps>
        );
    }
}
//给类添加公共方法
Object.assign(SgiSteps.prototype, sgiFormCtlBaseFun);
export { SgiSteps };
export default SgiSteps;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiSteps.js